<template>
    <div class='bxKbjs box noBtn'>
        <div class='jsy'>
            <p>本次开标到此结束！</p>
            <p>谢谢大家！</p>
        </div>
    </div>
</template>
<script>
export default {
    name:'kbjs',
    data(){
        return{
        }
    },
    methods:{
        getData(lx){
            console.log(lx)
        }
    }
}
</script>
<style lang="less">
.bxKbjs{
    position: relative;
    .jsy{
        font-size: 50px;
        font-weight: bold;
        color:#333;
        width: 500px;
        height:160px;
        text-align: center;
        line-height:80px;
        position: absolute;
        left: 50%;
        top:50%;
        margin-left:-250px;
        margin-top:-140px; 
    }
}
</style>